<template>
  <div id="installsTab">
    <b-table-simple v-if="$store.state.global.installs" striped>
      <b-thead>
        <b-tr>
          <b-th><span v-label-key="'INSTALLS_ID'">ID1</span></b-th>
          <b-th><span v-label-key="'INSTALLS_USERAGENT'">UserAgent</span></b-th>
          <b-th><span v-label-key="'INSTALLS_AGENT'">Agent</span></b-th>
          <b-th><span v-label-key="'INSTALLS_OS'">OS</span></b-th>
          <b-th
            ><span v-label-key="'INSTALLS_HARD_VERSION'"
              >Hard Version</span
            ></b-th
          >
          <b-th
            ><span v-label-key="'INSTALLS_SOFT_VERSION'"
              >Soft Version</span
            ></b-th
          >
          <b-th
            ><span v-label-key="'INSTALLS_LOGIN_DATE'"
              >Date of login</span
            ></b-th
          >
          <b-th
            ><span v-label-key="'INSTALLS_LOGIN_TIME'"
              >Time of login</span
            ></b-th
          >
          <b-th><span v-label-key="'INSTALLS_ACTIONS'">Actions</span></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="install in displayInstalls" :key="install.id">
          <b-td>{{ install.id }}</b-td>
          <b-td>{{ install.user_agent }}</b-td>
          <b-td>{{ install.agent.family }}</b-td>
          <b-td>{{ install.os.family }}</b-td>
          <b-td>{{ install.hard_version }}</b-td>
          <b-td>{{ install.soft_version }}</b-td>
          <b-td>{{
            install.updated
              .split('')
              .slice(0, 10)
              .join('')
          }}</b-td>
          <b-td>{{
            install.updated
              .split('')
              .slice(11, 23)
              .join('')
          }}</b-td>
          <b-td>
            <b-button
              v-if="install.refresh_token"
              :disabled="!install.refresh_token"
              variant="danger"
              @click="disableInstall(install)"
            >
              <span v-label-key="'DISABLE'">Disable</span>
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import $api from '@/services/api';

export default {
  name: 'InstallsTab',
  props: ['store_id'],
  computed: {
    displayInstalls() {
      return this.$store.state.global.installs.filter(
        install => !install.revoked
      );
    },
  },
  created(){
    this.refreshData();
  },
  methods: {
    disableInstall(install) {
      $api.delete(`/v1/dashboard/installs/${install.id}`).then(() => {
        install.revoked = true;
        alert(
          this.$store.getters['translations/getLabels']('ALERT_USER_DISABLED')
        ); // eslint-disable-line no-alert
      });
    },
    refreshData() {
      this.$store.dispatch('global/getInstalls', {
        store_id: this.store_id,
      });
    },
  },
};
</script>
